import React, { useState, useRef, useEffect } from 'react';
import RadioGroup from 'syf-component-library/ui/patterns/RadioGroup';
import Radio from 'syf-component-library/ui/atoms/Radio';
import { ControlWrapper } from './control.styles';
import styled from 'styled-components';
const StyledRadioGroup = styled(RadioGroup) `
    &>legend {
        margin-bottom: 20px;
        font-weight: bold;
    }
    &>div {
        padding: 7px;
        margin: 0px;
        border-bottom: solid 1px #c8c8c8;
        background-color: #ffffff;
    }

    &>div:first-of-type {
        border-radius: 10px 10px 0 0;

    }
    &>div:last-child {
        border-radius: 0 0 10px 10px;
    }
    &>div >label > span > span > span {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%)
    }
`;
const RadioButtonControl = (props) => {
    const [options] = useState(() => props.inputMetadata.value.map(val => (val.SubmitValue)));
    const [surveyInput, setSurveyInput] = useState('');
    const [isrequired] = useState(props.inputMetadata.required === 'true');
    const rdoRef = useRef(null);
    useEffect(() => {
        if (props.shouldFocus && (rdoRef === null || rdoRef === void 0 ? void 0 : rdoRef.current)) {
            rdoRef.current.focus();
        }
    });
    const onChange = (option) => {
        const inputText = option;
        setSurveyInput(inputText);
        props.onChange({
            id: props.inputMetadata.id,
            isvalid: !!(isrequired && option) || !isrequired,
            value: option,
        });
    };
    return (React.createElement(ControlWrapper, { hasError: !!props.error },
        React.createElement(StyledRadioGroup, { className: "radio-group", onChange: onChange, selected: surveyInput }, options.map((value, index) => (React.createElement(Radio, { id: `survey-dialog-option-${index}`, name: `survey-dialog-option`, key: `survey-dialog-option-${index}`, value: value, radioRef: rdoRef }, value))))));
};
export default RadioButtonControl;
